export default "__VITE_ASSET__DyWhWbpq__"